import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import ArrowLinkGroup from '~/client/components/arrow-link-group/arrow-link-group';
import ContentContainer from '~/client/components/content-container/content-container';
import type { BootCampShop as Props } from './boot-camp-shop.types';

const BootCampShop: React.FC<Props> = ({ events, title }) => (
  <main className="boot-camp-shop">
    <ContentContainer>
      <div className="boot-camp-shop__content">
        <Text
          elementName="h1"
          size={Text.sizes.headline1}
          theme={Text.themes.headline}
        >
          {title}
        </Text>
        <ArrowLinkGroup {...events} />
      </div>
    </ContentContainer>
  </main>
);

export default BootCampShop;
